import { useEffect } from "react";
import type { FieldPath, FieldPathValue, FieldValues, UseFormReturn } from "react-hook-form";

export function useFormDefault<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>(
  form: UseFormReturn<TFieldValues>,
  name: TName,
  value: FieldPathValue<TFieldValues, TName> | undefined,
) {
  useEffect(() => {
    if (value !== undefined && !form.getValues(name)) {
      form.setValue(name, value);
    }
  }, [value]);
}
